import { Component, OnInit } from '@angular/core';
import { UiBreadcrumbItem, UiUserInfo } from '../../models/ui-sidebar.model';
import { UiTableColumn } from '../../models/ui-table.model';
import {
  SHOWCASE_MENU_SECTIONS,
  SHOWCASE_MOCK_DATA,
  SHOWCASE_TABLE_COLUMNS,
  MockRequisition,
  createShowcaseFilters,
  toTableRows,
} from './ui-showcase.data';

@Component({
  selector: 'app-ui-showcase',
  templateUrl: './ui-showcase.component.html',
  styleUrls: ['./ui-showcase.component.scss']
})
export class UiShowcaseComponent implements OnInit {
  menuSections = SHOWCASE_MENU_SECTIONS;
  activePath = 'requisition-master';
  sidebarCollapsed = false;
  title = 'Purchase Requisition';
  breadcrumbs: UiBreadcrumbItem[] = [
    { label: 'Dashboard' },
    { label: 'Procurement' },
  ];
  user: UiUserInfo = {
    userName: 'Admin',
    companyName: 'Pradhan Associates Pvt. Ltd',
    initials: 'AD',
  };

  columns: UiTableColumn[] = SHOWCASE_TABLE_COLUMNS;
  filters = createShowcaseFilters();
  searchTerm = '';
  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  currentPage = 1;
  totalPages = 1;

  private allData: MockRequisition[] = SHOWCASE_MOCK_DATA;
  filteredData: MockRequisition[] = [];

  ngOnInit(): void {
    this.applyFilters();
  }

  get statCards() {
    const data = this.allData;
    return {
      total: data.length,
      approved: data.filter(d => d.status === 'Approved').length,
      pending: data.filter(d => d.status === 'Pending').length,
      rejected: data.filter(d => d.status === 'Rejected').length,
    };
  }

  get tableRows(): Record<string, unknown>[] {
    return toTableRows(this.filteredData);
  }

  get tableSubtitle(): string {
    return `Showing ${this.filteredData.length} of ${this.allData.length} records`;
  }

  onSearch(term: string): void {
    this.searchTerm = term;
    this.applyFilters();
  }

  onFilterChange(event: { key: string; value: string }): void {
    const filter = this.filters.find(f => f.key === event.key);
    if (filter) {
      filter.value = event.value;
    }
    this.applyFilters();
  }

  onSort(event: { column: string; direction: 'asc' | 'desc' }): void {
    this.sortColumn = event.column;
    this.sortDirection = event.direction;
    this.applyFilters();
  }

  onLinkClick(event: { row: Record<string, unknown>; column: string }): void {
    console.log('Link clicked:', event.row['reqNo'], event.column);
  }

  onActionClick(event: { row: Record<string, unknown>; type: string }): void {
    console.log('Action:', event.type, 'on', event.row['reqNo']);
  }

  onExport(): void {
    console.log('Export clicked');
  }

  onCreate(): void {
    console.log('Create clicked');
  }

  onNavigate(path: string): void {
    this.activePath = path;
    console.log('Navigate to:', path);
  }

  onLogout(): void {
    console.log('Logout clicked');
  }

  onSidebarToggle(collapsed: boolean): void {
    this.sidebarCollapsed = collapsed;
  }

  private applyFilters(): void {
    let result = [...this.allData];

    if (this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase();
      result = result.filter(item =>
        item.reqNo.toLowerCase().includes(term) ||
        item.branch.toLowerCase().includes(term) ||
        item.section.toLowerCase().includes(term) ||
        item.remark.toLowerCase().includes(term)
      );
    }

    const statusFilter = this.filters.find(f => f.key === 'status');
    if (statusFilter && statusFilter.value !== 'all') {
      result = result.filter(item => item.status === statusFilter.value);
    }

    const typeFilter = this.filters.find(f => f.key === 'type');
    if (typeFilter && typeFilter.value !== 'all') {
      result = result.filter(item => item.type === typeFilter.value);
    }

    if (this.sortColumn) {
      const key = this.sortColumn as keyof MockRequisition;
      result.sort((a, b) => {
        const aVal = String(a[key] ?? '');
        const bVal = String(b[key] ?? '');
        const cmp = aVal.localeCompare(bVal);
        return this.sortDirection === 'asc' ? cmp : -cmp;
      });
    }

    this.filteredData = result;
    this.totalPages = 1;
    this.currentPage = 1;
  }
}
